/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Audience_NoneInputs */



/**
* | output |
* | --- |
* | "Everyone" |
*
* @param {Settings_Template_Audience_NoneInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_audience_none = /** @type {((inputs?: Settings_Template_Audience_NoneInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Audience_NoneInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Iedereen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout le monde")
	return /** @type {LocalizedString} */ ("Everyone")
});